<template>
  <div class="campaign-type-modal rounded overflow-hidden text-dark bg-white p-3.5">
    <div class="campaign-type-modal__header flex items-center justify-between gap-3 mb-3.5">
      <div class="flex items-center gap-1">
        <svg class="text-bordersDark" width="16" height="16" fill="none">
          <use :xlink:href="`#${icon}`"></use>
        </svg>
        <h2 class="campaign-type-modal__title font-bold mb-0">{{ title }}</h2>
      </div>
      <button class="campaign-type-modal__close text-base" @click="$emit('close')"><i class="icon-Close font-bold"></i></button>
    </div>
    <!-- body -->
    <div class="campaign-type-modal__body mb-3.5 text-[13px] leading-5 break-normal">
      <slot></slot>
    </div>
    <!-- end body -->
    <!-- Footer -->
    <div class="campaign-type-modal__footer-action flex justify-end items-center gap-2">
      <slot name="footer"></slot>
    </div>
    <!-- end -->
  </div>
</template>
<script>
export default {
  name: 'SendToReview',
  props: {
    icon: {
      type: String,
      default: 'delete',
    },
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
